import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { TestConstant } from 'src/app/constants/label-constants';
import { CollageModel } from 'src/app/models/collageModel';
import { CommonService } from 'src/app/services/common/common.service';
@Component({
  selector: 'app-test-detail',
  templateUrl: './test-detail.component.html',
  styleUrls: ['./test-detail.component.scss']
})
export class TestDetailComponent {
  testId: number = 0;
  TestDetail: any = [];
  CollegeDetail: any = [];
  CommonConstant: any = [];
  TestConstant: any = [];
  showData: boolean = false;
  flag: boolean = false;
  displayedColumns: string[] = ['rowNumber', 'college', 'selectedbatches'];
  dataSource: MatTableDataSource<CollageModel> = new MatTableDataSource();

  constructor(
    private apiUrl: ApiUrlHelper,
    public modalService: NgbActiveModal,
    private spinner: NgxSpinnerService,
    public commonService: CommonService,
  ) { }

  ngOnInit(): void {
    this.TestConstant = TestConstant;
    this.CommonConstant = CommonConstant;
    this.getTestDetails(this.testId);
    this.spinner.show();
  }

  getTestDetails(testId: number) {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.test.TestCollegeBatchDetailsById.replace("{examId}", testId.toString());
    this.commonService.doGet(apiUrl).pipe().subscribe({
      next: async (response) => {
        if (response.success) {
          this.TestDetail = response.data;
          this.dataSource.data = response.data.college;
          this.spinner.hide();
          this.flag = true;
        }
        else {
          this.spinner.hide();
        }
      },
      error: (error) => {
        this.spinner.hide();
      }
    });
  }
  // Replace with the path to your placeholder image
  handleImageError(event: any) {
    event.target.src = '../../../assets/img/default_college.png';
    event.onerror = null;
  }
}
